import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function Footer() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      // Check if user has scrolled near the bottom (within 100px of bottom)
      const isNearBottom =
        scrollPosition + windowHeight >= documentHeight - 100;
      setIsScrolled(isNearBottom || scrollPosition > 10);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <footer
      className={`relative z-10 mt-auto w-full border-t transition-all duration-300 ${
        isScrolled
          ? 'border-brand-primary/40 bg-brand-primary/30 backdrop-blur-lg backdrop-saturate-150'
          : 'border-transparent bg-transparent backdrop-blur-0 backdrop-saturate-100'
      }`}
    >
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6 grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4 flex items-center gap-3">
              <img
                src="https://res.cloudinary.com/dwhpimotj/image/upload/v1758543752/logo_pnm9g9.png"
                alt="CYB Logo"
                className="h-8 w-auto"
              />
              <span className="font-heading text-xl font-bold text-brand-accent">
                CYB
              </span>
            </div>
            <p className="mb-4 font-body text-sm text-neutral-medium">
              {t('footer.internalUse')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 font-heading font-semibold text-brand-accent">
              {t('footer.links.about')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="font-body text-sm text-neutral-medium transition-colors duration-200 hover:text-brand-accent"
                >
                  {t('footer.links.about')}
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="font-body text-sm text-neutral-medium transition-colors duration-200 hover:text-brand-accent"
                >
                  {t('footer.links.support')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="mb-4 font-heading font-semibold text-brand-accent">
              {t('footer.links.terms')}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="font-body text-sm text-neutral-medium transition-colors duration-200 hover:text-brand-accent"
                >
                  {t('footer.links.privacy')}
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="font-body text-sm text-neutral-medium transition-colors duration-200 hover:text-brand-accent"
                >
                  {t('footer.links.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright – السنة تتحدث تلقائياً */}
        <div className="border-t border-neutral-dark/50 pt-6">
          <p className="text-center font-body text-sm text-neutral-medium">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
}
